import { render, staticRenderFns } from "./pos-requests-status.vue?vue&type=template&id=5183a975"
import script from "./pos-requests-status.vue?vue&type=script&lang=js"
export * from "./pos-requests-status.vue?vue&type=script&lang=js"
import style0 from "./pos-requests-status.vue?vue&type=style&index=0&id=5183a975&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports